export default {
    imageCheck(image) {
        const env = process.env.VUE_APP_BASE_URL + process.env.VUE_APP_STORAGE
        return !image ? require('@/assets/product-default.jpg') : env + image 
    },
    tableQueryBuilder(options) {
        const { page , sortBy , sortDesc } = options
        let params = {
          page: page
        }
        let sortMethod = sortDesc[0] ? 'desc' : 'asc'
        if (sortBy.length > 0) {
          let sortType = sortBy[0] == 'price' ? 'orderby_price' :
                         sortBy[0] == 'name' ? 'orderby_name' : 
                         sortBy[0] == 'category.name' ? 'orderby_name' : 
                         sortBy[0] == 'offer' ? 'orderby_offer' : 
                         sortBy[0] == 'id' ? 'orderby_id' : 
                         sortBy[0] == 'created_at' ? 'orderby_date' :
                         sortBy[0] == 'total' ? 'orderby_total' : 
                         null
          params[sortType] = sortMethod
        }
        return params
    },
    checkIsValid(items, exceptions) {
        return Object.keys(items).filter(i=> !exceptions.includes(i)).map((item) => items[item]).some(item => !item || Array.isArray(item) && item.length == 0 ? true : false)
    },
    numberWithCommas(number) {
        return number ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : '-';
    },
    getNormalDate(date){
        return new Date(date).toLocaleString().split(',')[0]
    }
}
